<div class="d-flex flex-column gap-2">
  @for (notif of notifications; track notif; let i = $index) {
    <a class="w-100 bg-light border border-dark font-11 d-flex align-items-center rounded py-1 px-2 no-decoration"
      [href]="notif.url" [ngClass]="{'no-hover':!notif.url}"
      (click)="checkNotification(notif, i , $event)">
      <div class="flex-fill">{{notif.message}}</div>
      <div class="text-end">
        <button class="btn btn-sm border border-black" (click)="checkNotification(notif, i, $event, true); ">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
    </a>
  }
</div>
